import { CreditNoteRepository } from "../repositories/CreditNoteRepository";
import { CreditNoteOperationResult } from "../entities/CreditNoteEntity";

/**
 * Delete Credit Note Use Case
 * Handles deletion of credit notes (both draft and posted)
 */
export class DeleteCreditNoteUseCase {
  constructor(private repository: CreditNoteRepository) {}

  async execute(
    creditNoteId: number | string
  ): Promise<CreditNoteOperationResult> {
    return await this.repository.deleteCreditNote(creditNoteId);
  }
}
